import e from "i18next";
import s from "../../../node_modules/lodash/merge.js";
import { initReactI18next as o } from "react-i18next";
import { defaultLanguage as t, supportedLngs as n } from "./constants.js";
import { locales as a } from "./locales/index.js";
const r = a;
async function c({ locales: a2, appNamespaces: c2, lng: l, supportedLangs: p, fallbackLng: i, defaultNS: m, instance: u } = {}) {
  const f = u ?? e, d = s({}, r, a2), g = l ?? t;
  return await f.use(o).init({ resources: d, ns: c2 ? [...Object.keys(r[g]), ...c2] : Object.keys(d[g]), defaultNS: m ?? "common", supportedLngs: p ?? [...n], fallbackLng: i ?? t, interpolation: { escapeValue: false }, lng: g, react: { useSuspense: false } }), f;
}
export {
  c as initI18nInstance
};
//# sourceMappingURL=initI18nInstance.js.map
